import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Poe2Navbar from '../Components/layout/Poe2Navbar';

function Poe2Layout() {
  return (
    <>
      <Poe2Navbar />
      <Box component="main" className="app-container" sx={{ py: 3 }}>
        <Outlet />
      </Box>
    </>
  );
}

export default Poe2Layout;
